import { expenseCalendarDate } from './expense_days';
/** Client-local today during the journey; its first day before or after it. */
export function defaultFormDate(startValue, finishValue, now = new Date()) {
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const calendarDate = (value) => {
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
        }
        const text = String(value !== null && value !== void 0 ? value : '').trim();
        const local = text.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
        return expenseCalendarDate(local ? `${local[3]}-${local[2]}-${local[1]}` : text);
    };
    const start = calendarDate(startValue);
    const finish = calendarDate(finishValue);
    if (start && (today < start || (finish && today > finish)))
        return start;
    if (finish && today > finish)
        return finish;
    return today;
}
